/* eslint-disable */
import { useState, useRef } from 'react';
import { Box, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useReactToPrint } from 'react-to-print';
export default function Receipt({ receiptHtml, openReceipt, handleClose }) {
    const [fullWidth] = useState(true);
    const [maxWidth] = useState('lg');

    const handlePrint = useReactToPrint({ content: () => componentRef.current });
    const componentRef = useRef(null);

    const responseData = receiptHtml;

    return (
        <>
            <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={openReceipt} onClose={handleClose} disableEscapeKeyDown={false}>
                <div ref={componentRef} id="print-content">
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 2
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: responseData }} />
                    </Box>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2
                    }}
                >
                    <Button variant="contained" onClick={handlePrint} sx={{ ml: 1 }}>
                        Print
                    </Button>
                </Box>
            </Dialog>
        </>
    );
}
